import gql from 'graphql-tag'

export const CHANGE_USER_STATUS = gql`
  mutation changeUserStatus($userUuid: GUID!, $enabled: Boolean!) {
    changeUserStatus(userUuid: $userUuid, enabled: $enabled) {
      enabled
    }
  }
`
